// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1009":"css/app.6659","3322":"css/admin-app.6659"}[chunkId] + ".css";
};